// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__uaGiU","horizontal":"Divider_horizontal__2HADO","vertical":"Divider_vertical__z7oux"};